import { Badge, Tooltip } from "@mantine/core";
import { isOpenNow, localTimeIn } from "@/lib/format";

interface OpenNowBadgeProps {
  timezone: string;
  openingTime: string | null | undefined;
  closingTime: string | null | undefined;
}

/** Open/closed relative to the store's own wall clock, not the viewer's. */
export function OpenNowBadge({
  timezone,
  openingTime,
  closingTime,
}: OpenNowBadgeProps) {
  const open = isOpenNow(timezone, openingTime, closingTime);
  const now = localTimeIn(timezone);

  if (open === null) {
    return (
      <Badge color="gray" variant="light">
        Unknown
      </Badge>
    );
  }

  return (
    <Tooltip label={`${now} local (${timezone})`} withArrow>
      <Badge color={open ? "teal" : "gray"} variant="light">
        {open ? "Open" : "Closed"}
      </Badge>
    </Tooltip>
  );
}
